import { PublicationContentType } from '@app/entities/enums/multimedia/content-status-types.enum';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

import { Publication } from './publication.model';

export class InternalLink extends Publication {
  contentType = PublicationContentType.INTERNAL;
  source: string;
  internalLink: string;

  constructor(data: MSafeAny) {
    super(data);
    this.source = data.source;
    this.internalLink = data.internal_link;
  }
}
